import { exerciseDetailsActionTypes } from './Constants';

export function startExerciseRequest() {
	return {
		type: exerciseDetailsActionTypes.START_EXERCISE_REQUEST,
	};
}

export function startExerciseSuccess(data) {
	return {
		type: exerciseDetailsActionTypes.START_EXERCISE_REQUEST_SUCCESS,
		payload: {
			data,
		},
	};
}

export function startExerciseError() {
	return {
		type: exerciseDetailsActionTypes.START_EXERCISE_REQUEST_ERROR,
	};
}

export function restartExerciseRequest(data) {
	return {
		type: exerciseDetailsActionTypes.RESTART_EXERCISE_REQUEST,
		payload: { data },
	};
}

export function restartExerciseSuccess(data) {
	return {
		type: exerciseDetailsActionTypes.RESTART_EXERCISE_REQUEST_SUCCESS,
		payload: {
			data,
		},
	};
}

export function restartExerciseError() {
	return {
		type: exerciseDetailsActionTypes.START_EXERCISE_REQUEST_ERROR,
	};
}

export function setSelectedItems(data) {
	return {
		type: exerciseDetailsActionTypes.SET_SELECTED_ITEMS,
		payload: {
			data,
		},
	};
}

export function skipOnboardingRequest(data) {
	return {
		type: exerciseDetailsActionTypes.SKIP_ONBOARDING_REQUEST,
		payload: {
			data,
		},
	};
}

export function skipOnboardingSuccess(data) {
	return {
		type: exerciseDetailsActionTypes.SKIP_ONBOARDING_SUCCESS,
		payload: {
			data,
		},
	};
}

export function skipOnboardingError() {
	return {
		type: exerciseDetailsActionTypes.SKIP_ONBOARDING_ERROR,
	};
}

export function setStartExercise() {
	return {
		type: exerciseDetailsActionTypes.SET_START_EXERCISE,
	};
}

export function sendAnswerRequest(data, code) {
	return {
		type: exerciseDetailsActionTypes.SEND_ANSWER_REQUEST,
		payload: {
			data,
			code,
		},
	};
}

export function sendAnswerSuccess(data, streaks) {
	return {
		type: exerciseDetailsActionTypes.SEND_ANSWER_SUCCESS,
		payload: {
			data,
			streaks,
		},
	};
}

export function sendAnswerError() {
	return {
		type: exerciseDetailsActionTypes.SEND_ANSWER_ERROR,
	};
}

export function clearState() {
	return {
		type: exerciseDetailsActionTypes.CLEAR_STATE,
	};
}

export function saveSettingsRequest(data) {
	return {
		type: exerciseDetailsActionTypes.SAVE_SETTINGS_REQUEST,
		payload: {
			data,
		},
	};
}

export function saveSettingsSuccess(data) {
	return {
		type: exerciseDetailsActionTypes.SAVE_SETTINGS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function saveSettingsError() {
	return {
		type: exerciseDetailsActionTypes.SAVE_SETTINGS_ERROR,
	};
}

export function setHintType(data) {
	return {
		type: exerciseDetailsActionTypes.SET_HINT_TYPE,
		payload: {
			data,
		},
	};
}

export function saveSubtypeRequest(data) {
	return {
		type: exerciseDetailsActionTypes.SAVE_SUBTYPE_REQUEST,
		payload: {
			data,
		},
	};
}

export function saveSubtypeSuccess(data) {
	return {
		type: exerciseDetailsActionTypes.SAVE_SUBTYPE_SUCCESS,
		payload: {
			data,
		},
	};
}

export function saveSubtypeError() {
	return {
		type: exerciseDetailsActionTypes.SAVE_SUBTYPE_ERROR,
	};
}

export function setExerciseScore(data) {
	return {
		type: exerciseDetailsActionTypes.SET_EXERCISE_SCORE,
		payload: {
			data,
		},
	};
}

export function resumePausedExerciseRequest(data) {
	return {
		type: exerciseDetailsActionTypes.RESUME_PAUSED_EXERCISE_REQUEST,
		payload: data,
	};
}

export function resumePausedExerciseSuccess(data) {
	return {
		type: exerciseDetailsActionTypes.RESUME_PAUSED_EXERCISE_SUCCESS,
		payload: {
			data,
		},
	};
}

export function resumePausedExerciseError() {
	return {
		type: exerciseDetailsActionTypes.RESUME_PAUSED_EXERCISE_ERROR,
	};
}

export function setIsRestart(data) {
	return {
		type: exerciseDetailsActionTypes.SET_IS_RESTART,
		payload: {
			data,
		},
	};
}

export function setCurrentListId(data) {
	return {
		type: exerciseDetailsActionTypes.SET_CURRENT_LIST_ID,
		payload: {
			data,
		},
	};
}

export function toggleSettingsModal(data) {
	return {
		type: exerciseDetailsActionTypes.TOGGLE_SETTINGS_MODAL,
		payload: {
			data,
		},
	};
}

export function handleExerciseTypes(displayType) {
	return {
		type: exerciseDetailsActionTypes.HANDLE_EXERCISE_TYPES,
		payload: {
			displayType,
		},
	};
}
export function handleWordsTypoChecker(wordTuples) {
	return {
		type: exerciseDetailsActionTypes.HANDLE_WORDS_TYPO_CHECKER,
		payload: {
			wordTuples,
		},
	};
}
export function handleWordsTypoCheckerSuccess(checkedWords) {
	return {
		type: exerciseDetailsActionTypes.HANDLE_WORDS_TYPO_CHECKER_SUCCESS,
		payload: {
			checkedWords,
		},
	};
}
